import { render, staticRenderFns } from "./KeywordTree.vue?vue&type=template&id=22af6181&scoped=true"
import script from "./KeywordTree.vue?vue&type=script&lang=js"
export * from "./KeywordTree.vue?vue&type=script&lang=js"
import style0 from "./KeywordTree.vue?vue&type=style&index=0&id=22af6181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af6181",
  null
  
)

export default component.exports